import { Component, OnInit, OnDestroy } from "@angular/core";
import { DataService_imagemaint } from "../shared/data.service";

import { wsImageLibraryListInfo } from "../shared/wsImageLibraryListInfo";
import { wsImageLibraryRenameParm } from "../shared/wsImageLibraryRenameParm";

import { DynamicDialogRef, DynamicDialogConfig } from "primeng/dynamicdialog";

@Component({
	selector: "app-root",
	templateUrl: "./imagerename.component.html",
	styleUrls: ["./imagerename.component.css"],
})
export class ImageRenameComponent implements OnInit, OnDestroy {
	constructor(private dataService: DataService_imagemaint, public ref: DynamicDialogRef, public dialogConfig: DynamicDialogConfig) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Globals
	//
	//-----------------------------------------------------------------------------------------------------
	public isBusy: boolean = false;

	public SelectedImageLibraryItem: wsImageLibraryListInfo;

	public NewImageLibraryItemName: string = "";
	public ErrorMessage: string = "";

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnInit
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnInit() {
		this.SelectedImageLibraryItem = this.dialogConfig.data.SelectedItem;
		this.NewImageLibraryItemName = this.SelectedImageLibraryItem.ImageLibraryItemName;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnDestroy
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnDestroy() {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onRename
	//
	//-----------------------------------------------------------------------------------------------------
	onRename() {
		let parms: wsImageLibraryRenameParm = {
			ImageLibraryID: this.SelectedImageLibraryItem.ImageLibraryID,
			NewImageLibraryItemName: this.NewImageLibraryItemName.trim(),
		};

		this.isBusy = true;
		this.dataService.ImageLibraryRename(parms).subscribe((data) => this.ImageLibraryRename_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ImageLibraryRename_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	ImageLibraryRename_Complete(data: any) {
		this.isBusy = false;
		this.ErrorMessage = data[0];

		//
		// 0 = CANCEL; 1 = SAVE
		//
		if (this.ErrorMessage.length == 0) {
			this.ref.close(1);
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onClose
	//
	//-----------------------------------------------------------------------------------------------------
	onClose() {
		//
		// 0 = CANCEL; 1 = SAVE
		//
		this.ref.close(0);
	}
}
